'use client';
import React, { useState, useRef } from 'react';

const UserAvatar = ({ src, alt }: { src: string; alt: string }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement | null>(null);
  const avatarRef = useRef<HTMLDivElement | null>(null);

  // Fonction pour afficher le popover
  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  // Fonction pour cacher le popover
  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <div
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={avatarRef}
    >
      <div className="minthr-flex minthr-flex-items-center minthr-flex-justify-center">
        <img
          className={'minthr-avatar minthr-avatar-m minthr-mr-2'}
          src={`${src}`}
          alt={alt}
        />
      </div>
      {isOpen && (
        <div
          ref={popoverRef}
          className="minthr-user-info-shortcut minthr-box-shadow minthr-p-3 minthr-bg-white"
          style={{ top: -65, left: -70 }} // Ensure initial top/left values do not interfere with absolute positioning
        >
          <div className="minthr-flex minthr-flex-items-center">
            <div className="minthr-flex minthr-flex-space-start minthr-flex-items-center">
              <img
                className="minthr-avatar minthr-avatar-m shortcut-profilePicture"
                src="/uploads/getprofileimage/32768dab-dfc2-4145-b904-0c1156bcc63a"
                alt=""
              />
              <div className="minthr-flex minthr-flex-column minthr-ml-2">
                <h6 className="minthr-line-height-10 shortcutt-fullname">
                  {' '}
                  abdelhak latrach{' '}
                </h6>
                <h6 className="minthr-color-gray minthr-line-height-10 shortcutt-departement">
                  {' '}
                </h6>
              </div>
            </div>

            <button className="minthr-btn minthr-btn-secondary minthr-btn-s minthr-ml-auto shortcut-ChatBubble">
              <img
                className="minthr-icon-s"
                src="/icons/chat-bubble.svg"
                alt="chat-bubble"
              />
            </button>

            <a
              className="minthr-btn minthr-btn-primary minthr-btn-s minthr-ml-1 shortcut-ProfilRedirect"
              href="/employee/32768dab-dfc2-4145-b904-0c1156bcc63a/profile/public"
            >
              <img
                className="minthr-icon-s"
                src="/newtheme/dist/icons/arrow.svg"
                alt="arrow"
              />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
